module.exports = __webpack_public_path__ + "static/media/dark_logo_transparent_background.f8887d1d.png";